import { useMutation, useQueryClient } from '@tanstack/react-query'
import { getAmplifyClient } from '@/services/amplifyClient'
import {
  createShopMutation,
  updateShopMutation,
} from '@/services/graphql/mutations'
import { userKeys } from '@/services/user/user.keys'
import type {
  CreateShopInput,
  UpdateShopInput,
} from '@/features/shop/shop.types'

const client = getAmplifyClient()

export const useCreateShop = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['createShop'],
    mutationFn: createShop,
    onSuccess: (variables) => {
      queryClient.refetchQueries({
        queryKey: userKeys.current(),
      })
      if (variables.organizationID) {
        queryClient.refetchQueries({
          queryKey: ['organization', variables.organizationID],
        })
      }
    },
  })
}

export const useUpdateShop = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['updateShop'],
    mutationFn: updateShop,
    onSuccess: (shopID) => {
      queryClient.refetchQueries({
        queryKey: ['shop', shopID],
      })
    },
  })
}

const createShop = async (variables: CreateShopInput) => {
  try {
    await client.graphql({
      query: createShopMutation,
      variables: { input: variables },
    })
    return variables
  } catch (error) {
    console.error('createShopMutation', error)
    throw error
  }
}

const updateShop = async (variables: UpdateShopInput) => {
  try {
    await client.graphql({
      query: updateShopMutation,
      variables: { input: variables },
    })
    return variables.id
  } catch (error) {
    console.error(error)
    throw error
  }
}
